module.exports = __webpack_public_path__ + "static/media/restore.f9d7d5e4.svg";